import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import {
    mdiAccountCircle,
    mdiAccountCircleOutline,
    mdiAccountGroupOutline,
    mdiAccountMultipleOutline,
    mdiAccountOutline,
    mdiAccountTieOutline,
    mdiAlertCircleOutline,
    mdiArrowLeftCircle,
    mdiCalendarArrowRight,
    mdiCalendarBlank,
    mdiCalendarBlankMultiple,
    mdiCalendarCheckOutline,
    mdiCalendarEnd,
    mdiCalendarRemove,
    mdiCalendarStart,
    mdiCash,
    mdiCashCheck,
    mdiCardAccountDetailsOutline,
    mdiCashOff,
    mdiChatQuestionOutline,
    mdiCheckCircle,
    mdiCheckCircleOutline,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiChevronUp,
    mdiCircleOffOutline,
    mdiClipboardCheckMultipleOutline,
    mdiCloseCircleOutline,
    mdiDownload,
    mdiEmailMultipleOutline,
    mdiEmailOpenOutline,
    mdiEmailOutline,
    mdiFolder,
    mdiForum,
    mdiHelpCircleOutline,
    mdiInformationSlabCircleOutline,
    mdiLinkVariant,
    mdiLinkVariantPlus,
    mdiMapMarkerMultipleOutline,
    mdiMapMarkerOutline,
    mdiMessageArrowLeftOutline,
    mdiMessageArrowRightOutline,
    mdiPencil,
    mdiPlus,
    mdiReply,
    mdiRobotConfused,
    mdiRobotDead,
    mdiRobotOff,
    mdiSendVariantOutline,
    mdiShare,
    mdiShieldAccount,
    mdiTableEdit,
    mdiTablePlus,
    mdiTabletCellphone,
    mdiTag,
    mdiTagMultipleOutline,
    mdiTagOff,
    mdiTagOutline,
    mdiThumbDownOutline,
    mdiThumbUpOutline,
    mdiTimer,
    mdiTimerOff,
    mdiTranslateVariant,
    mdiTrashCan,
    mdiTrashCanOutline
} from '@mdi/js';
import { theme_dark, theme_light } from '~/themes/themes'

export default defineNuxtPlugin(async (nuxtApp) => {
    const vuetify = createVuetify({
      components: {},
        icons: {
            defaultSet: 'mdi',
            aliases: {
                ...aliases,
                'mdi-account-circle': mdiAccountCircle,
                'mdi-account-circle-outline': mdiAccountCircleOutline,
                'mdi-account-group-outline': mdiAccountGroupOutline,
                'mdi-account-multiple-outline': mdiAccountMultipleOutline,
                'mdi-account-outline': mdiAccountOutline,
                'mdi-account-tie-outline': mdiAccountTieOutline,
                'mdi-alert-circle-outline': mdiAlertCircleOutline,
                'mdi-arrow-left-circle': mdiArrowLeftCircle,
                'mdi-calendar-arrow-right': mdiCalendarArrowRight,
                'mdi-calendar-blank': mdiCalendarBlank,
                'mdi-calendar-blank-multiple': mdiCalendarBlankMultiple,
                'mdi-calendar-check-outline': mdiCalendarCheckOutline,
                'mdi-calendar-end': mdiCalendarEnd,
                'mdi-calendar-start': mdiCalendarStart,
                'mdi-calendar-remove': mdiCalendarRemove,
                'mdi-card-account-details-outline': mdiCardAccountDetailsOutline,
                'mdi-cash': mdiCash,
                'mdi-cash-check': mdiCashCheck,
                'mdi-cash-off': mdiCashOff,
                'mdi-chat-question-outline': mdiChatQuestionOutline,
                'mdi-check-circle': mdiCheckCircle,
                'mdi-check-circle-outline': mdiCheckCircleOutline,
                'mdi-chevron-down': mdiChevronDown,
                'mdi-chevron-left': mdiChevronLeft,
                'mdi-chevron-right': mdiChevronRight,
                'mdi-chevron-up': mdiChevronUp,
                'mdi-circle-off-outline': mdiCircleOffOutline,
                'mdi-clipboard-check-multiple-outline': mdiClipboardCheckMultipleOutline,
                'mdi-close-circle-outline': mdiCloseCircleOutline,
                'mdi-download': mdiDownload,
                'mdi-email-multiple-outline': mdiEmailMultipleOutline,
                'mdi-email-open-outline': mdiEmailOpenOutline,
                'mdi-email-outline': mdiEmailOutline,
                'mdi-folder': mdiFolder,
                'mdi-forum': mdiForum,
                'mdi-help-circle-outline': mdiHelpCircleOutline,
                'mdi-information-slab-circle-outline': mdiInformationSlabCircleOutline,
                'mdi-link-variant': mdiLinkVariant,
                'mdi-link-variant-plus': mdiLinkVariantPlus,
                'mdi-map-marker-multiple-outline': mdiMapMarkerMultipleOutline,
                'mdi-map-marker-outline': mdiMapMarkerOutline,
                'mdi-message-arrow-left-outline': mdiMessageArrowLeftOutline,
                'mdi-message-arrow-right-outline': mdiMessageArrowRightOutline,
                'mdi-pencil': mdiPencil,
                'mdi-plus': mdiPlus,
                'mdi-reply': mdiReply,
                'mdi-robot-confused': mdiRobotConfused,
                'mdi-robot-dead': mdiRobotDead,
                'mdi-robot-off': mdiRobotOff,
                'mdi-send-variant-outline': mdiSendVariantOutline,
                'mdi-share': mdiShare,
                'mdi-shield-account': mdiShieldAccount,
                'mdi-table-edit': mdiTableEdit,
                'mdi-table-plus': mdiTablePlus,
                'mdi-tablet-cellphone': mdiTabletCellphone,
                'mdi-tag': mdiTag,
                'mdi-tag-multiple-outline': mdiTagMultipleOutline,
                'mdi-tag-off': mdiTagOff,
                'mdi-tag-outline': mdiTagOutline,
                'mdi-thumb-down-outline': mdiThumbDownOutline,
                'mdi-thumb-up-outline': mdiThumbUpOutline,
                'mdi-timer': mdiTimer,
                'mdi-timer-off': mdiTimerOff,
                'mdi-translate-variant': mdiTranslateVariant,
                'mdi-trash-can': mdiTrashCan,
                'mdi-trash-can-outline': mdiTrashCanOutline
            },
            sets: {
                mdi,
            },
        },
      defaults: {
         global: {
            ripple: true
         },
         VAppBar: {
            elevation: 2
         },
         VBtn: {
            class: 'text-body-1',
            rounded: 'lg'
         },
         VCard: {
            class: 'emboss',
            density: 'compact',
            elevation: 8,
            rounded: 'lg'
         },
         VCardActions: {
            VBtn: {
               class: 'text-body-1 rounded-pill',
               density: 'compact'
            }
         },
         VCardText: {
            class: 'pa-3 text-body-1',
            style: 'background: linear-gradient(rgb(var(--v-theme-surfaceEdgeRight)) 0px, rgb(var(--v-theme-surface)) 32px, rgb(var(--v-theme-surface)) calc(100% - 32px), rgb(var(--v-theme-surfaceEdgeLeft)) 100%); border-top: 1px solid rgb(var(--v-theme-surfaceEdgeBottom)); border-bottom: 1px solid rgb(var(--v-theme-surfaceEdgeTop));'
         },
         VCardTitle: {
            class: "align-center d-flex"
         },
         VCheckbox: {
            color: 'secondary'
         },
         VCombobox: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            variant: 'underlined',
            validateOn: 'blur'
         },
         VDataTableServer: {
            fixedHeader: true,
            noDataText: 'no data available'
         },
         VDivider: {
            class: 'border-opacity-25'
         },
         VFooter: {
            elevation: 8,
            style: 'border-top: 1px solid rgb(var(--v-theme-surfaceLight))'
         },
         VNavigationDrawer: {
            elevation: 4
         },
         VRadioGroup: {
            color: 'secondary'
         },
         VSelect: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            variant: 'underlined',
            validateOn: 'blur'
         },
         VSheet: {
            border: true
         },
         VTextarea: {
            density: 'compact',
            variant: 'underlined'
         },
         VTextField: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            hideDetails: 'auto',
            variant: 'underlined',
            validateOn: 'blur'
         },
         VToolbar: {
            color: 'surface',
            density: 'compact',
            VBtn: {
               class: 'mr-2',
               style: 'background: rgba(var(--v-theme-surfaceLight), 0.6); height: calc(var(--v-btn-height) - 8px);'
            }
         },
         VToolbarTitle: {
            class: 'mx-0'
         },
         VTooltip: {
            location: 'top'
         }
      },
      display: {
         mobileBreakpoint: 'md',
      },
      theme: {
         defaultTheme: 'theme_light',
         variations: {
            colors: ['primary', 'secondary', 'surfaceDark'],
            lighten: 3,
            darken: 3
         },
         themes: {
            theme_dark,
            theme_light
         }
      }
   })

   nuxtApp.vueApp.use(vuetify)
})
